export default __webpack_public_path__ + "static/media/minus.206547b0.svg";